import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { DashboardService } from "src/app/services/dashboard.service";
import { SessionService } from "src/app/services/session.service";
import { DataService } from "src/app/services/data.service";
import { FilterService } from "src/app/services/filter.service";
import { combineLatest, debounceTime, Subscription } from "rxjs";
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import { DeviceDetectionService } from "src/app/services/detectipad.service";
import { MatDialog } from "@angular/material/dialog";
import { SelectionPopupComponent } from "../shared/selection-popup/selection-popup.component";
import { ConstantsService } from "src/app/services/constants.service";
import { UserActivityService } from "src/app/services/useractivity.service";
import { ApiService } from "src/app/services/api.service";
import { NavigationService } from "src/app/services/navigation.service";
import { WidgetService } from "src/app/services/widget.service";
import { PowerBiService } from "src/app/components/powerbi/services/powerbi.service";
import {
  getPowerBiFolderForModule,
  mapPowerBiReportToDashboardCard,
} from "src/app/components/powerbi/powerbi-module-folder.config";
import {
  getStaticDashboardsForModule,
  mapStaticDashboardToCard,
} from "src/app/components/static-dashboard/static-dashboard.config";
import {
  getUsageDashboardsForModule,
  mapUsageDashboardToCard,
} from "src/app/components/ai-usage/ai-usage.config";
import { EnhancementService } from "src/app/services/enhancements-service";
import { DashboardAccessStorageService } from "src/app/services/dashboard-access-storage.service";

/** Case Management uses direct/ page routing instead of standard dashboard/page. */
const CASE_MANAGEMENT_MODULE_KEY = 100119;

@Component({
  selector: "app-dashboard",
  templateUrl: "./dashboard.component.html",
  styleUrls: ["./dashboard.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DashboardComponent implements OnInit, OnDestroy {
  userName: string = "";
  clientKey: any;
  moduleKey: any;
  module: any;
  pages: any;
  title: any;
  logoImage: any;
  colorCodes: any = [];
  colors: any;
  pageLogo: any;
  pageInfo: any;
  selectConfig!: any;
  DbPages: any;
  newColor: any;
  clientLogo: any;
  checkFlag = true;

  brandKeyData: any[] = [];
  test: any;
  page_nm: any;
  reqSubcription: Subscription[] = [];
  moduleName: any;

  // for Auto Complete

  @ViewChild("brandkeySelection", { static: true })
  brandkeySelection!: ElementRef;

  constructor(
    private dashboardService: DashboardService,
    private sessionService: SessionService,
    private router: ActivatedRoute,
    private route: Router,
    private dataService: DataService,
    private navigationService: NavigationService,
    private dialog: MatDialog,
    private apiService: ApiService,
    public filterService: FilterService,
    public deviceDetectionService: DeviceDetectionService,
    private constantsService: ConstantsService,
    private userActivityService: UserActivityService,
    private cdr: ChangeDetectorRef,
    private widgetService: WidgetService,
    private powerBiService: PowerBiService,
    private enhancementService: EnhancementService,
    private dashboardAccessStorage: DashboardAccessStorageService
  ) {}

  isIpad = false;
  ngOnInit(): void {
    this.reqSubcription.push(
      combineLatest([
        this.router.params,
        this.router.queryParams,
      ]).subscribe(([routeParams, queryParams]) => {
        this.moduleName = routeParams["module"] || "";

        const decryptedParams = this.navigationService.decryptData(queryParams);
        this.clientKey = decryptedParams["cl_key"];
        this.moduleKey = decryptedParams["md_key"];

        if (!this.clientKey) {
          return;
        }

        this.newColor = this.sessionService.getColorCodes();
        this.userName = this.sessionService.getUsername();
        this.filterService.refreshData = false;
        this.selectConfig = sessionStorage.getItem("selectConfig");
        this.dashboardService.moduleKey = this.moduleKey;

        this.getDashboardData();
        sessionStorage.removeItem("tbl_name_suffix");
        this.clientLogo = this.sessionService.getClintLogo();

        this.cdr.detectChanges();
        if (this.selectConfig == "DB") {
          this.getWorknames();
        } else {
          this.selectConfig = "S3";
        }
      })
    );

    // if(this.clientKey) {
    //   // get Logos
    //   this.apiService.getlogos().subscribe((res:any)=>{
    //     // console.log(res)
    //     if(res.length>0){
    //       sessionStorage.setItem('logos', JSON.stringify(res))
    //     }else{
    //       alert(" brand logos not found")
    //     }
    //   },(err:any)=>{alert(" brand logos not found")})
    // }
  }

  gettingDatafromPopup() {
    this.dialog.closeAll();

    let dialogRef = this.dialog.open(SelectionPopupComponent, {
      width: this.constantsService.MEDIUM_DIALOG_BOX_WIDTH,
      disableClose: true,
      panelClass: "du-custom-modalbox",
    });

    dialogRef.afterClosed().subscribe((value) => {
      if (value) {
        this.setBrandKey(value?.brand_key);
        sessionStorage.setItem("tbl_name_suffix", JSON.stringify(value));
      }
    });
  }

  getDashboardData() {
    let body = {
      username: this.userName,
      client_key: this.clientKey,
      module_key: this.moduleKey,
    };

    if (this.dashboardService.menuItems?.length > 0) {
      let fndModule = this.dashboardService.menuItems.find(
        (f: any) => f.access_flg == "Y" && this.moduleKey == f.module_key
      );
      if (fndModule) {
        this.dashboardService.userMenuModuleHandle(false, fndModule);
      }
    }

    this.reqSubcription.push(
      this.dashboardService
        .getDashboardAccess(body)
        .pipe(debounceTime(500))
        .subscribe(
          (pages) => {
            this.pages = pages ?? [];
            // this.enhancementService.sendAllPageInfoData(this.pages);
            // Persist dashboardAccess in IndexedDB, keyed by moduleKey, so topnav
            // can read it back from storage instead of the in-memory subject.
            this.dashboardAccessStorage.saveDashboardAccess(
              this.moduleKey,
              this.pages
            );
            this.cdr.detectChanges();
            this.appendStaticDashboards();
            this.appendUsageDashboards();
            this.appendPowerBiReports();
          },
          (err) => {
            console.log(err);
          }
        )
    );
  }

  /** Adds frontend-only static dashboard cards for configured modules. */
  private appendStaticDashboards(): void {
    const staticDashboards = getStaticDashboardsForModule(Number(this.moduleKey));
    if (!staticDashboards.length) {
      return;
    }

    const dbPages = (this.pages ?? []).filter(
      (page: any) => !page?.isStaticDashboard && !page?.isUsageDashboard
    );
    this.pages = [
      ...dbPages,
      ...staticDashboards.map((def) => mapStaticDashboardToCard(def)),
    ];
    this.cdr.detectChanges();
  }

  /** Adds frontend-only AI usage dashboard cards for configured modules. */
  private appendUsageDashboards(): void {
    const usageDashboards = getUsageDashboardsForModule(Number(this.moduleKey));
    if (!usageDashboards.length) {
      return;
    }

    const dbPages = (this.pages ?? []).filter(
      (page: any) => !page?.isUsageDashboard
    );
    this.pages = [
      ...dbPages,
      ...usageDashboards.map((def) => mapUsageDashboardToCard(def)),
    ];
    this.cdr.detectChanges();
  }

  /** Loads Power BI cards in the background so DB dashboards stay clickable immediately. */
  private appendPowerBiReports(): void {
    const folderName = getPowerBiFolderForModule(Number(this.moduleKey));
    if (!folderName) {
      return;
    }

    this.reqSubcription.push(
      this.powerBiService
        .getReportsByFolder(folderName)
        .pipe(
          catchError((err) => {
            console.error("Failed to load Power BI reports", err);
            return of([]);
          })
        )
        .subscribe((reports) => {
          if (!reports?.length) {
            return;
          }

          // Rebuild from the DB pages only, so overlapping/repeated loads can't
          // append the same Power BI cards more than once.
          const dbPages = (this.pages ?? []).filter(
            (page: any) =>
              !page?.isPowerBiReport &&
              !page?.isStaticDashboard &&
              !page?.isUsageDashboard
          );
          this.pages = [
            ...dbPages,
            ...reports.map((report) => mapPowerBiReportToDashboardCard(report)),
          ];
          this.cdr.detectChanges();
        })
    );
  }

  openPage(page: any, hist_flg?: any) {
    if (page.isUsageDashboard) {
      this.navigationService.routerNavigate(`dashboard/${this.moduleName}/usage`, {
        cl_key: this.clientKey,
        md_key: this.moduleKey,
      });
      return;
    }

    if (page.isStaticDashboard) {
      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}/static/${page.staticDashboardId}`,
        {
          cl_key: this.clientKey,
          md_key: this.moduleKey,
        }
      );
      return;
    }

    if (page.isPowerBiReport) {
      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}/powerbi/${page.reportId}`,
        {
          cl_key: this.clientKey,
          md_key: this.moduleKey,
        }
      );
      return;
    }

    sessionStorage.removeItem('selectedJSONSeq');
    sessionStorage.removeItem("source_patient_id");
    sessionStorage.removeItem("tbl_name_suffix_non_frm");
    sessionStorage.removeItem("navDetailInfo");


    // reset the Time Cycle filter to default when we navigate to new page
    this.userActivityService.clearTimeCycleFilter();
    /////////////////////////////////////

    let dashboardDetail = {
      dashboard_nm: page.dashboard_nm,
      work_nm: page.work_nm,
      dashboard_key: page.dashboard_key,
    };
    sessionStorage.setItem("navbar_page_nm", JSON.stringify(dashboardDetail));
    this.userActivityService.setData({ pageTab: 0 });
    this.checkFlag = true;
    this.filterService.sliderValue = 1;

    page.brand_json_flg = 'Y';

    let query: any = {
      tab_id: 0,
      cl_key: this.clientKey,
      md_key: this.moduleKey,
      ds_key: page.dashboard_key || page.work_key,
    };

    if (hist_flg) {
      query["hist_flg"] = hist_flg;
    }

    this.widgetService.pageHeaderWidgets = [];

    if (this.moduleKey == CASE_MANAGEMENT_MODULE_KEY) {
      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}/${"direct"}/${page.dashboard_nm}`,
        query
      );
    } else {
      this.navigationService.routerNavigate(
        `dashboard/${this.moduleName}/${"page"}`,
        query
      );
    }
    // this.route.navigate([`dashboard/${this.clientKey}/${this.moduleKey}/${page.dashboard_key || page.work_key}`]);
  }

  openHistoryPage(page: any) {
    this.openPage(page, "H");
  }

  getWorknames() {
    this.dataService.getWorkList().subscribe((req) => {
      this.DbPages = req;
    });
  }

  getBrandName() {
    let url = "kpi/get-brand-filter";
    this.filterService
      .loadData("post", url, "client_key", "")
      .subscribe((res: any) => {
        this.brandKeyData = res ? res : [];
      });
  }

  setBrandKey(brand: any) {
    // debugger
    if (brand) {
      sessionStorage.setItem("brandKeyForFilters", JSON.stringify(brand));
      // sessionStorage.setItem("brandName", brand);
      this.getDashboardData();
      this.checkFlag = true;

      this.clientLogo = this.filterService.getBrandLogo({ brand_key: brand });
    }
  }

  onFilterTextBoxChanged($event: any) {
    return ($event.target as HTMLInputElement).value;
  }

  selectedWork: any;

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }
}
